module.exports = __webpack_public_path__ + "img/Logo-light.ee22d074.svg";